export const lightPalette = {
    bg: '#F4F6FB',
    card: '#FFFFFF',
    card2: '#EDF1F8',
    line: '#DCE3EE',
    sheet: 'rgba(255,255,255,0.94)',
    scrim: 'rgba(15,23,42,0.45)',
    text: '#0F172A',
    text2: '#334155',
    muted: '#535E72',
    accent: '#2563EB',
    accentText: '#1D4ED8',
    accentSoft: '#E7EEFD',
    onAccent: '#FFFFFF',
    danger: '#B42318',
    dangerSoft: '#FDECEA',
    ok: '#0F766E',
    okSoft: '#DCF3EE',
    warn: '#8A4B08',
    warnSoft: '#FBE9D2',
    info: '#0E7490',
    infoSoft: '#DFF4F8',
    favorite: '#B23C0B',
    favoriteSoft: '#FCEFE1',
    brand: ['#1E3A8A', '#2563EB', '#0F766E'],
    brandAlt: ['#7C3AED', '#4F46E5'],
    onBrand: '#FFFFFF',
};
export const darkPalette = {
    bg: '#0B1120',
    card: '#111A2E',
    card2: '#18233B',
    line: '#25324E',
    sheet: 'rgba(17,26,46,0.94)',
    scrim: 'rgba(0,0,0,0.6)',
    text: '#F1F5F9',
    text2: '#CBD5E1',
    muted: '#98A6BB',
    accent: '#60A5FA',
    accentText: '#93C5FD',
    accentSoft: '#16264A',
    onAccent: '#0B1120',
    danger: '#F28B82',
    dangerSoft: '#3A1E1C',
    ok: '#5EEAD4',
    okSoft: '#10302C',
    warn: '#F2B46A',
    warnSoft: '#3A2E1C',
    info: '#67E8F9',
    infoSoft: '#0E2A33',
    favorite: '#F2B46A',
    favoriteSoft: '#3A2E1C',
    brand: ['#93C5FD', '#60A5FA', '#2DD4BF'],
    brandAlt: ['#C4B5FD', '#A5B4FC'],
    onBrand: '#0B1120',
};
export const palettes = { light: lightPalette, dark: darkPalette };
/** Corner radii shared by buttons, cards and sheets. */
export const radius = { chip: 999, button: 16, card: 20, sheet: 24 };
//# sourceMappingURL=theme.js.map